/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react'

import { SyncOutlined } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, useTheme } from '@mui/material'
import { red } from '@mui/material/colors'

import * as serviceWorker from './serviceWorkerRegistration'

const ServiceWorkerWrapper = () => {
  const [showReload, setShowReload]       = useState(false)
  const [waitingWorker, setWaitingWorker] = useState(null)
  const theme                             = useTheme()

  const onSWUpdate = (registration) => {
    setShowReload(true)
    setWaitingWorker(registration.waiting)
  }

  useEffect(() => {
    console.log('sw register')
    serviceWorker.register({ onUpdate: onSWUpdate })
  }, [])

  const reloadPage = () => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' })
    setShowReload(false)
    window.location.reload()
  }
  const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="up" ref={ref} {...props} />
  })
  return (
  // <Snackbar open={showReload} anchorOrigin={{vertical: 'top',horizontal: 'center'}} onClick={reloadPage}>
  //   <Alert onClose={reloadPage} variant='filled' severity="error" action={<Button
  //         color="inherit"
  //         size="small"
  //         onClick={reloadPage}
  //       >
  //         Güncelle
  //       </Button>}>
  //     Yen versiyon var. Hemen güncelleyin!
  //   </Alert>
  // </Snackbar>

    <Dialog
      open={showReload}
      onClick={reloadPage}
      TransitionComponent={Transition}
    >
      <DialogTitle>{'Yeni Güncelleme '}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Uygulamayı kullanım esnasında sıkıntı yaşamamanız adına güncelleme yapmanız gerekmektedir.
        </DialogContentText>

      </DialogContent>
      <DialogActions>
        <Button
          disableFocusRipple
          variant="contained"
          endIcon={<SyncOutlined />}
          style={
            {
              margin: 'auto',
              backgroundColor: red[500],
              color: theme.palette.getContrastText(red[600]),

              textTransform: 'none'
            }
          }
          onClick={reloadPage}
        >
          Hemen Güncelle
        </Button>
      </DialogActions>
    </Dialog>

  )
}

export default ServiceWorkerWrapper
